/**
 * 自动保存文档到CMIS，文本提示
 * 用于顶部状态栏提示
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './SavingTip.scss';
import { store } from 'Store/store.index';
import intl from 'react-intl-universal';

@inject('storageAppStore', 'docStore')
@observer
class SavingTip extends Component {
    constructor(props) {
        super(props);
    }
    render () {
        let { autoSaveStatus, storageDriveName } = store.storageAppStore;
        const { docDriveName } = store.docStore;
        if (docDriveName !== storageDriveName) {
            autoSaveStatus = null;
        }

        const { isAUserGroup } = store.accountStore;
        return (
            ['loading', 'success'].includes(autoSaveStatus) &&
            <div className='storage-save-status'>
                {
                    isAUserGroup && autoSaveStatus === 'loading' &&  <span>
                        <i className='icon'>
                            <svg className='spin' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_13566_395607)">
                                    <path d="M1.28559 4.33382C1.19367 4.59421 1.33025 4.87982 1.59065 4.97173C1.85105 5.06365 2.13665 4.92707 2.22857 4.66667L1.28559 4.33382ZM10.714 7.6667C10.8059 7.40631 10.6694 7.1207 10.409 7.02877C10.1486 6.93683 9.86299 7.07339 9.77106 7.33379L10.714 7.6667ZM3.99986 2.536C5.91303 1.43143 8.35939 2.08693 9.46396 4.0001L10.33 3.5001C8.94927 1.10864 5.89132 0.289264 3.49986 1.66998L3.99986 2.536ZM7.99986 9.4642C6.08669 10.5688 3.64033 9.91327 2.53576 8.0001L1.66973 8.5001C3.05044 10.8916 6.1084 11.7109 8.49986 10.3302L7.99986 9.4642ZM2.53576 8.0001C2.42933 7.81577 2.33937 7.62679 2.26531 7.43482L1.33233 7.79473C1.42497 8.03489 1.53729 8.27072 1.66973 8.5001L2.53576 8.0001ZM9.46396 4.0001C9.60878 4.25095 9.72315 4.51045 9.80844 4.77448L10.76 4.46709C10.6532 4.13643 10.5103 3.81233 10.33 3.5001L9.46396 4.0001ZM2.22857 4.66667C2.53497 3.79862 3.1401 3.03238 3.99986 2.536L3.49986 1.66998C2.42592 2.29002 1.66836 3.24942 1.28559 4.33382L2.22857 4.66667ZM9.77106 7.33379C9.46463 8.20173 8.85954 8.96787 7.99986 9.4642L8.49986 10.3302C9.5737 9.71025 10.3312 8.75097 10.714 7.6667L9.77106 7.33379Z" fill="#BE70CA"/>
                                    <path d="M0.906893 8.56524L1.15684 6.92415C1.17613 6.79745 1.30796 6.72134 1.42734 6.76798L2.97353 7.37206C3.12973 7.43309 3.14598 7.64771 3.00075 7.73156L1.20461 8.76856C1.05938 8.85241 0.881643 8.73103 0.906893 8.56524Z" fill="#BE70CA"/>
                                    <path d="M11.0931 3.43476L10.8432 5.07585C10.8239 5.20255 10.692 5.27866 10.5727 5.23202L9.02647 4.62794C8.87027 4.56691 8.85402 4.35229 8.99925 4.26844L10.7954 3.23144C10.9406 3.14759 11.1184 3.26897 11.0931 3.43476Z" fill="#BE70CA"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_13566_395607">
                                        <rect width="12" height="12" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>

                        </i>
                        {intl.get('FoxitStorage.AutoSave.Saving')}
                    </span>
                }
                {
                    isAUserGroup && autoSaveStatus === 'success' && <span>
                        <i className='icon'>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="4.5" stroke="#BE70CA"/>
                                <path d="M4 6L5.5 7.5L8 5" stroke="#BE70CA" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>

                        </i>
                        {intl.get('FoxitStorage.AutoSave.SavedAt')} {
                            (() => {
                                const date = new Date();
                                let hour = date.getHours();
                                if (hour < 10) hour = '0' + hour;
                                let minute = date.getMinutes();
                                if (minute < 10) minute = '0' + minute;
                                let second = date.getSeconds();
                                if (second < 10) second = '0' + second;
                                store.storageAppStore.setCurAutoSavedAtTime(hour + ':' + minute + ':' + second);
                                return hour + ':' + minute + ':' + second
                            })()
                        }
                    </span>
                }
            </div>
        );
    }
}
export default SavingTip;
